type ApiFailure = {
  response?: { status?: number; data?: { error?: { message?: string; type?: string; errors?: unknown } } }
}

export function failureStatus(failure: unknown) {
  return (failure as ApiFailure)?.response?.status
}

export function failureType(failure: unknown) {
  return (failure as ApiFailure)?.response?.data?.error?.type
}

/**
 * Field errors from an API validation failure, keyed by the form field names in `fields`. The API keys errors by
 * attribute with full messages (`{ username: ['Username is already taken'] }`); `rename` maps an attribute to a
 * differently named field. Returns null when nothing maps, so the caller can show a general error instead.
 */
export function fieldErrorsFrom(failure: unknown, fields: readonly string[], rename: Record<string, string> = {}) {
  const errors = (failure as ApiFailure)?.response?.data?.error?.errors
  if (!errors || typeof errors !== 'object' || Array.isArray(errors)) return null
  const mapped: Record<string, string[]> = {}
  for (const [attribute, messages] of Object.entries(errors as Record<string, unknown>)) {
    const field = rename[attribute] ?? attribute
    if (!fields.includes(field)) continue
    const list = (Array.isArray(messages) ? messages : [messages]).filter((message): message is string => typeof message === 'string')
    if (list.length) mapped[field] = list
  }
  return Object.keys(mapped).length ? mapped : null
}
